import React, { useEffect, useRef } from 'react'
import { HearkenStatus } from 'types/hearkenStatus'
import styles from './styles.module.scss'
import config from 'config'

interface Props {
  hearkenStatus: HearkenStatus
}

const embeds: { [P in HearkenStatus]: string[] } = config.embeds

export function HearkenEmbed({ hearkenStatus }: Props) {
  const divElement = useRef<HTMLDivElement>(null)
  const embed = embeds[hearkenStatus]

  useEffect(() => {
    if (embed.length > 0) {
      embed.forEach(embedSrc => {
        const script = window.document.createElement('script')
        script.async = true
        script.src = embedSrc
        divElement.current && divElement.current.appendChild(script)
      })
    }
  }, [embed, divElement.current])

  if (!embed) {
    return null
  }
  return <div ref={divElement} className={styles.hearkenEmbed} id='embed' />
}
